import { NgClass } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  imports: [FlexLayoutModule, NgClass],
  selector: 'iot-platform-ui-cards-container',
  templateUrl: './cards-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./cards-container.component.scss']
})
export class CardsContainerComponent {
  horizontalLayout = input<boolean>(false);
  virtualScroll = input<boolean>(false);
}
